module.exports = __webpack_public_path__ + "img/1.7e2f0dfb.jpeg";